import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import convert from '../../helpers/convert'
import format from '../../helpers/format'
import {
  Link,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsSjf.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsSjf extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    this.state = {
      // gef_score: props.company.gef_score ? convert.float(props.company.gef_score) * 100 : null,
      // dei_score: props.company.dei_score ? convert.float(props.company.dei_score) * 100 : null,
      // rji_score: props.company.rji_score ? convert.float(props.company.rji_score) * 100 : null,
      // hrc_score: props.company.hrc_score ? convert.float(props.company.hrc_score) * 100 : null,
    }
  }

  render() {
    const iconGef = require( '../../../static/images/icn-gef-black.svg' )

    return <div styleName='family-modal'>
      <div styleName='icon-row'>
        {
          this.props.company.gef_score ?
            <CompanyIsFlag icon={iconGef} title='Rated on Gender Equality'/> :
            null
        }
        {
          this.props.company.dei_score ?
            <CompanyIsFlag icon={iconGef} title='Rated on Diversity Disclosures'/> :
            null
        }
        {
          this.props.company.rji_score ?
            <CompanyIsFlag icon={iconGef} title='Rated on Racial Justice'/> :
            null
        }
        {
          this.props.company.hrc_score ?
            <CompanyIsFlag icon={iconGef} title='Rated on LGBTQ+ Equity'/> :
            null
        }
      </div>
      {
        this.props.company.gef_score ?
          <div>
            <p><b>Gender equality:</b> This company has been rated by
            Equileap's Gender Equality Scorecard.
            The score contributes to our Gender Equality Funds
            and Social Justice Funds scores.</p>
            <br/>
          </div> :
          null
      }
      {
        this.props.company.dei_score ?
          <div>
            <p><b>Diversity Disclosures:</b> This company has been rated
            by <i>As You Sow</i> and Whistle Stop
            Capital's Workplace Equity Scorecard.
            The score contributes to our Social Justice Funds scores.</p>
            <br/>
          </div> :
          null
      }
      {
        this.props.company.rji_score ?
          <div>
            <p><b>Racial Justice:</b> This company has been rated by <i>As
            You Sow</i>'s Racial Justice Scorecard.
            The score contributes to our Social Justice Funds scores.</p>
            <br/>
          </div> :
          null
      }
      {
        this.props.company.hrc_score ?
          <div>
            <p><b>LGBTQ+ Equity:</b> This company has been
            rated by the Human Rights Campaign's Corporate Equality Index.
            The score contributes to our Social Justice Funds scores.</p>
            <br/>
          </div> :
          null
      }
    </div>
  }
}
